
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cf0I9", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => (parcelRequire("lT9x0")).EngagementSpotlight);

var $aPN1a = parcelRequire("aPN1a");
var $343k9 = parcelRequire("343k9");
var $7UDun = parcelRequire("7UDun");





var $lT9x0 = parcelRequire("lT9x0");

var $fvNZm = parcelRequire("fvNZm");

var $l29nK = parcelRequire("l29nK");


});
parcelRegister("l29nK", function(module, exports) {

$parcel$export(module.exports, "EngagementMessages", () => $2b0b847559baffc5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bWIRa = parcelRequire("bWIRa");

var $ajjxD = parcelRequire("ajjxD");

var $kcfPJ = parcelRequire("kcfPJ");
class $2b0b847559baffc5$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kcfPJ.default), {}),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ajjxD.default), {}),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bWIRa.default), {})
            ]
        });
    }
}

});
parcelRegister("bWIRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7dce8e60b6f3cc$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $9vPaT = parcelRequire("9vPaT");

var $5nYbP = parcelRequire("5nYbP");

var $eeKRK = parcelRequire("eeKRK");
const $6e7dce8e60b6f3cc$export$42b694a35bb75eda = (0, $9vPaT.default)((0, $eeKRK.default));
var $6e7dce8e60b6f3cc$export$2e2bcd8739ae039 = (0, $5nYbP.default)($6e7dce8e60b6f3cc$export$42b694a35bb75eda, 'contextualSurvey');

});
parcelRegister("eeKRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe04eacd78ae490$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $d7nfl = parcelRequire("d7nfl");

var $3pZc2 = parcelRequire("3pZc2");

var $hTIKH = parcelRequire("hTIKH");

var $iZ5Xj = parcelRequire("iZ5Xj");
function $0fe04eacd78ae490$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d7nfl.default), {
        shouldShow: true,
        children: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $iZ5Xj.default), {
                markAsSeenAndFatigued: (0, $3pZc2.markAsSeenAndFatigued),
                sendUserResponse: (0, $3pZc2.sendUserResponse),
                getFlag: (0, $hTIKH.getFlag),
                setFlag: (0, $hTIKH.setFlag),
                ...props
            })
    });
}

});
parcelRegister("d7nfl", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd39ae93725f342b$export$2e2bcd8739ae039);
/* SurveyMarshal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1aLTh = parcelRequire("1aLTh");

var $IW7jS = parcelRequire("IW7jS");
// 8px is the base unit in pixels
const $dd39ae93725f342b$var$surveyOffset = "var(--ds-space-600, 48px)";
const $dd39ae93725f342b$var$animationDuration = 300;
const $dd39ae93725f342b$var$offscreen = {
    // Hard-coded because there is no large enough space token and this component is not responsive.
    translateX: '488px',
    //survey container width + survey offset
    opacity: '0'
};
const $dd39ae93725f342b$var$getAnimationProps = (state)=>{
    switch(state){
        case 'entered':
            return {
                translateX: '0',
                opacity: '1'
            };
        case 'entering':
        case 'unmounted':
        case 'exited':
        case 'exiting':
            return $dd39ae93725f342b$var$offscreen;
    }
};
const $dd39ae93725f342b$var$transitionBaseStyles = null;
function $dd39ae93725f342b$export$2e2bcd8739ae039(props) {
    const { children: children, shouldShow: shouldShow } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1aLTh.default), {
        in: shouldShow,
        timeout: $dd39ae93725f342b$var$animationDuration,
        unmountOnExit: true,
        children: (state)=>{
            const { translateX: translateX, opacity: opacity } = $dd39ae93725f342b$var$getAnimationProps(state);
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                style: {
                    opacity: opacity,
                    transition: `all ${$dd39ae93725f342b$var$animationDuration}ms ease-in-out`,
                    zIndex: (0, $IW7jS.layers).flag(),
                    transform: `translateX(${translateX})`
                },
                className: (0, $hcewu.default)([
                    "_kqsw1n9t _1xi2oahv _94n5oahv _k8m01rjc"
                ]),
                children: children()
            });
        }
    });
}

});

parcelRegister("hTIKH", function(module, exports) {

$parcel$export(module.exports, "getFlag", () => $ae78eedcd6decac3$export$a19b74191e00c5e);
$parcel$export(module.exports, "setFlag", () => $ae78eedcd6decac3$export$5e165df1e30a1331);

var $l4vpb = parcelRequire("l4vpb");

var $9EWAY = parcelRequire("9EWAY");
const $ae78eedcd6decac3$var$hisiGetFlagTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($l4vpb))).parse('/engage-targeting/api/v2/user/{cloudId}/hisi/flag{?userKey,flagKey}');
const $ae78eedcd6decac3$export$9388e2e6cf5978f0 = '/engage-targeting/api/v2/user/{cloudId}/hisi/flag';
async function $ae78eedcd6decac3$export$a19b74191e00c5e(stargateUrl, cloudId, flagKey, userKey) {
    return (0, $9EWAY.stargateFetch)(`${stargateUrl}${$ae78eedcd6decac3$var$hisiGetFlagTemplate.expand({
        cloudId: cloudId,
        userKey: userKey,
        flagKey: flagKey
    })}`, {
        method: 'GET'
    }).then((0, $9EWAY.errorIfNotOk)).then((r)=>r.json());
}
async function $ae78eedcd6decac3$export$5e165df1e30a1331(stargateUrl, cloudId, flagKey, userKey) {
    return (0, $9EWAY.stargateFetch)(`${stargateUrl}${$ae78eedcd6decac3$export$9388e2e6cf5978f0}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userKey: userKey,
            flagKey: flagKey
        })
    }).then((0, $9EWAY.errorIfNotOk)).then((r)=>r).then(()=>Promise.resolve());
}

});

parcelRegister("iZ5Xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35dcacc62fbc0c2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9gqN4 = parcelRequire("9gqN4");
const $a35dcacc62fbc0c2$var$flagKey = 'atlassian_research_group_mailinglist_actioned';
class $a35dcacc62fbc0c2$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    firePrimaryClickEvent() {
        this.props.fireClickEvent('primary');
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9gqN4.default), {
            onDismiss: this.onDismiss,
            getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
            onMailingListAnswer: this.onMailingListAnswer,
            onSubmit: this.onSubmit,
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.onDismiss = (onDismissArgs)=>{
            const { cloudId: cloudId, messageId: messageId, fireClickEvent: fireClickEvent, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, orgId: orgId, workspaceId: workspaceId } = this.props;
            if (onDismissArgs.trigger === (0, $9gqN4.DismissTrigger).Manual) markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            fireClickEvent('dismiss');
        }, this.getUserHasAnsweredMailingList = async ()=>{
            const { stargateUrl: stargateUrl, aaid: aaid, cloudId: cloudId, getFlag: getFlag } = this.props;
            try {
                await getFlag(stargateUrl, cloudId, $a35dcacc62fbc0c2$var$flagKey, aaid);
                return Promise.resolve(false);
            } catch  {
                return Promise.resolve(true);
            }
        }, this.onSubmit = async (formValues)=>{
            const { cloudId: cloudId, messageId: messageId, question: question, statement: statement, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, sendUserResponse: sendUserResponse, orgId: orgId, workspaceId: workspaceId } = this.props;
            const { canContact: canContact, feedbackScore: feedbackScore, writtenFeedback: writtenFeedback } = formValues;
            const payload = {
                responseType: 'ACCEPTANCE_SURVEY',
                properties: {
                    surveyTimestamp: Date.now(),
                    contextualQuestion: question,
                    contextualStatement: statement,
                    quantitativeResponse: feedbackScore,
                    qualitativeResponse: writtenFeedback,
                    contactable: canContact
                }
            };
            markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            this.firePrimaryClickEvent();
            // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
            return sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(()=>Promise.resolve());
        }, this.onMailingListAnswer = async (answer)=>{
            const { aaid: aaid, cloudId: cloudId, stargateUrl: stargateUrl, messageId: messageId, sendUserResponse: sendUserResponse, setFlag: setFlag } = this.props;
            const payload = {
                responseType: 'MAILING_LIST_RESPONSE',
                properties: {}
            };
            setFlag(stargateUrl, cloudId, $a35dcacc62fbc0c2$var$flagKey, aaid);
            if (!answer) return;
            return sendUserResponse(cloudId, stargateUrl, messageId, payload);
        };
    }
}

});
parcelRegister("9gqN4", function(module, exports) {

$parcel$export(module.exports, "DismissTrigger", () => $70114318c7018c85$export$151efc60ac534d42);
$parcel$export(module.exports, "default", () => $70114318c7018c85$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9bOEU = parcelRequire("9bOEU");

var $d1JAu = parcelRequire("d1JAu");

var $jXf0Z = parcelRequire("jXf0Z");

var $i20bs = parcelRequire("i20bs");

var $2clDo = parcelRequire("2clDo");

var $kdDGz = parcelRequire("kdDGz");
var $70114318c7018c85$export$151efc60ac534d42 = /*#__PURE__*/ function(DismissTrigger) {
    DismissTrigger["AutoDismiss"] = "AUTO_DISMISS";
    DismissTrigger["Manual"] = "MANUAL";
    DismissTrigger["Finished"] = "FINISHED";
    DismissTrigger["Unmount"] = "UNMOUNT";
    return DismissTrigger;
}({});
const $70114318c7018c85$export$3e8963a077f85f25 = 8000;
var $70114318c7018c85$export$2e2bcd8739ae039 = ({ question: question, statement: statement, onDismiss: onDismiss, onSubmit: onSubmit, onMailingListAnswer: onMailingListAnswer, getUserHasAnsweredMailingList: getUserHasAnsweredMailingList, textLabel: textLabel = 'Why did you give that rating', textPlaceholder: textPlaceholder = 'Tell us why' })=>{
    const autoDisappearTimeoutRef = (0, $eJOHy.useRef)(null);
    // only allow a single dismiss for a component
    const isDismissedRef = (0, $eJOHy.useRef)(false);
    const tryDismiss = (0, $eJOHy.useCallback)((trigger)=>{
        // Already called dismiss once
        if (isDismissedRef.current) return;
        isDismissedRef.current = true;
        onDismissRef.current({
            trigger: trigger
        });
    }, []);
    const [currentStep, setCurrentStep] = (0, $eJOHy.useState)('SURVEY');
    const trySetCurrentStep = (0, $eJOHy.useCallback)((step)=>{
        // Already dismissed - cannot update the step
        if (isDismissedRef.current) return;
        setCurrentStep(step);
    }, [
        setCurrentStep
    ]);
    // using a ref so that we don't break all of our caches if a consumer is using an arrow function
    const onDismissRef = (0, $eJOHy.useRef)(onDismiss);
    (0, $eJOHy.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    // reset isDismissedRef.current on mount to be compatible with double render in react18 strict mode
    (0, $eJOHy.useEffect)(()=>{
        isDismissedRef.current = false;
    }, []);
    const tryClearTimeout = (0, $eJOHy.useCallback)(()=>{
        const id = autoDisappearTimeoutRef.current;
        if (id) {
            clearTimeout(id);
            autoDisappearTimeoutRef.current = null;
        }
    }, []);
    // Cleanup any auto dismiss after dismiss
    (0, $eJOHy.useEffect)(()=>{
        return function unmount() {
            tryClearTimeout();
            tryDismiss("UNMOUNT");
        };
    }, [
        tryClearTimeout,
        tryDismiss
    ]);
    const onSurveySubmit = (0, $eJOHy.useCallback)(async (formValues, form, callback = ()=>{})=>{
        // Submitting form: Phase 1 complete
        await onSubmit(formValues);
        // Note: need to call callback just before we navigate away
        // It cleans up the form (required)
        // Optional Phase 2: Asking to join Atlassian Research Group
        // Only enter phase 2 if:
        // 1. not already dismissed; AND
        // 2. permission given to contact; AND
        // 3. user has previously not answered mailing list question (getUserHasAnsweredMailingList returns false)
        // Not entering phase 2: User has dismissed while the submit promise was resolving
        if (isDismissedRef.current) {
            callback();
            return;
        }
        // Not entering phase 2: no permission given to respond to feedback
        if (!formValues.canContact) {
            callback();
            trySetCurrentStep('POST_SURVEY_NO_CONSENT');
            return;
        }
        const userHasAnswered = await getUserHasAnsweredMailingList();
        callback();
        // Not entering phase 2: user has already answered this question
        if (userHasAnswered) {
            trySetCurrentStep('POST_SURVEY_HAS_SIGN_UP');
            return;
        }
        // Enter phase 2
        trySetCurrentStep('SIGN_UP_PROMPT');
    }, [
        getUserHasAnsweredMailingList,
        onSubmit,
        trySetCurrentStep
    ]);
    const onMailingListResponse = (0, $eJOHy.useCallback)(async (answer)=>{
        await onMailingListAnswer(answer);
        if (answer) {
            trySetCurrentStep('SIGN_UP_SUCCESS');
            return;
        }
        // We have already thanked to user, we can simply close
        tryDismiss("FINISHED");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tryDismiss,
        trySetCurrentStep
    ]);
    // Start the auto disappear when we are finished
    (0, $eJOHy.useEffect)(()=>{
        // Already dismissed
        if (isDismissedRef.current) return;
        // Timeout already scheduled
        if (autoDisappearTimeoutRef.current) return;
        if ([
            'SIGN_UP_SUCCESS',
            'POST_SURVEY_NO_CONSENT',
            'POST_SURVEY_HAS_SIGN_UP'
        ].includes(currentStep)) autoDisappearTimeoutRef.current = window.setTimeout(()=>tryDismiss("AUTO_DISMISS"), $70114318c7018c85$export$3e8963a077f85f25);
    }, [
        currentStep,
        tryDismiss
    ]);
    (0, $kdDGz.default)({
        onDismiss: ()=>tryDismiss("MANUAL")
    });
    const content = (()=>{
        if (currentStep === 'SURVEY') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2clDo.default), {
            question: question,
            statement: statement,
            textLabel: textLabel,
            textPlaceholder: textPlaceholder,
            onSubmit: onSurveySubmit
        });
        if (currentStep === 'SIGN_UP_PROMPT') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d1JAu.default), {
            onAnswer: onMailingListResponse
        });
        if (currentStep === 'SIGN_UP_SUCCESS') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jXf0Z.default), {});
        if (currentStep === 'POST_SURVEY_NO_CONSENT' || currentStep === 'POST_SURVEY_HAS_SIGN_UP') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9bOEU.default), {});
        return null;
    })();
    const manualDismiss = (0, $eJOHy.useCallback)(()=>{
        // clear any pending timers
        tryClearTimeout();
        tryDismiss("MANUAL");
    }, [
        tryDismiss,
        tryClearTimeout
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i20bs.default), {
        onDismiss: manualDismiss,
        children: content
    });
};

});
parcelRegister("9bOEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c00e745da928d8f8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $6qNrL = parcelRequire("6qNrL");
var $c00e745da928d8f8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qNrL.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
            size: "xsmall",
            children: "Thanks for your feedback"
        })
    });

});
parcelRegister("6qNrL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c8ec1d47ddf137$export$2e2bcd8739ae039);
/* SuccessContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3TFuO = parcelRequire("3TFuO");

const $b0c8ec1d47ddf137$var$sectionStyles = null;
const $b0c8ec1d47ddf137$var$iconContainerStyles = null;
var $b0c8ec1d47ddf137$export$2e2bcd8739ae039 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("section", {
        className: (0, $hcewu.default)([
            "_18u01jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_kqswstnw _154iv47k _1ltv1ejb"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))), {
                    spacing: "spacious",
                    label: "",
                    "aria-hidden": true,
                    color: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$940e1f69e873f202)})`,
                    LEGACY_margin: "4px 0 0 0"
                })
            }),
            children
        ]
    });

});
var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';



parcelRegister("d1JAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f09358b99acf1e$export$2e2bcd8739ae039);
/* SignUpPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5CSKW = parcelRequire("5CSKW");

var $806LH = parcelRequire("806LH");

var $eJ9f5 = parcelRequire("eJ9f5");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $6qNrL = parcelRequire("6qNrL");
const $56f09358b99acf1e$var$buttonContainerStyles = null;
var $56f09358b99acf1e$export$2e2bcd8739ae039 = ({ onAnswer: onAnswer })=>{
    const [pending, setPending] = (0, $eJOHy.useState)(null);
    const answeredWith = (0, $eJOHy.useCallback)(async (answer)=>{
        setPending(answer ? 'yes' : 'no');
        await onAnswer(answer);
    }, [
        setPending,
        onAnswer
    ]);
    const isDisabled = Boolean(pending);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6qNrL.default), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "xsmall",
                children: "Thanks for your feedback"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                paddingBlockStart: "space.150",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                            as: "p",
                            children: "Are you interested in participating in our research?"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
                            as: "p",
                            children: [
                                "Sign up for the",
                                ' ',
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                                    href: "https://www.atlassian.com/research-group",
                                    target: "_blank",
                                    children: "Atlassian Research Group"
                                }),
                                ' ',
                                "and we may contact you in the future with research opportunities."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_19pkxy5q _1e0c1txw _1bahesu3 _pof3u2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "subtle",
                        onClick: ()=>answeredWith(false),
                        isDisabled: isDisabled,
                        isLoading: pending === 'no',
                        children: "No, thanks"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "primary",
                        onClick: ()=>answeredWith(true),
                        isDisabled: isDisabled,
                        isLoading: pending === 'yes',
                        children: "Yes, sign me up"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("jXf0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e5c97656b150857$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $6qNrL = parcelRequire("6qNrL");
var $0e5c97656b150857$export$2e2bcd8739ae039 = ({})=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qNrL.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: "xsmall",
                    children: "Thanks for signing up"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    as: "p",
                    children: "We may reach out to you in the future to participate in additional research."
                })
            ]
        })
    });

});

parcelRegister("i20bs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a271655ca30d4d$export$2e2bcd8739ae039);
/* SurveyContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $6J9k6 = parcelRequire("6J9k6");
const $e8a271655ca30d4d$var$containerStyles = null;
const $e8a271655ca30d4d$var$buttonWrapperStyles = null;
var $e8a271655ca30d4d$export$2e2bcd8739ae039 = ({ children: children, onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        style: {},
        className: (0, $hcewu.default)([
            "_2rko1sit _bfhk1bhr _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _16qshynm _1bsb1vif"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_kqswstnw _154ipxbi _1xi2pxbi"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
                    label: "Dismiss",
                    appearance: "subtle",
                    onClick: onDismiss
                })
            }),
            children
        ]
    });
};

});

parcelRegister("2clDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $317628e901f9ae29$export$2e2bcd8739ae039);
/* SurveyForm.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1aLTh = parcelRequire("1aLTh");

var $5CSKW = parcelRequire("5CSKW");

var $86tBw = parcelRequire("86tBw");

var $2yMqp = parcelRequire("2yMqp");
var $3L3Os = parcelRequire("3L3Os");
var $6svxr = parcelRequire("6svxr");
var $eRpdx = parcelRequire("eRpdx");

var $806LH = parcelRequire("806LH");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $dQmi3 = parcelRequire("dQmi3");

var $18XQs = parcelRequire("18XQs");
const $317628e901f9ae29$var$transitionBaseStyles = null;
const $317628e901f9ae29$var$getExpandedHeight = (ref, state)=>{
    if (!ref.current) return '0';
    switch(state){
        case 'entering':
            return `${ref.current.scrollHeight}px`;
        case 'entered':
            // needed for TextField auto height expand
            return `none`;
        default:
            return '0';
    }
};
const $317628e901f9ae29$var$transitionDuration = 200;
var $317628e901f9ae29$export$2e2bcd8739ae039 = ({ question: question, statement: statement, textPlaceholder: textPlaceholder, textLabel: textLabel, onSubmit: onSubmit })=>{
    const [expanded, setExpanded] = (0, $eJOHy.useState)(false);
    const [canContactDefault, setCanContactDefault] = (0, $eJOHy.useState)(false);
    const hasAutoFilledCanContactRef = (0, $eJOHy.useRef)(false);
    const expandedAreaRef = (0, $eJOHy.useRef)(null);
    const onScoreSelect = (0, $eJOHy.useCallback)(()=>{
        setExpanded(true);
    }, [
        setExpanded
    ]);
    // On the first type the user types some feedback we auto select
    // the option for allowing feedback. This automatic selection only
    // happens once. After that it is up to the user to control
    const onFeedbackChange = (0, $eJOHy.useCallback)(()=>{
        if (hasAutoFilledCanContactRef.current) return;
        hasAutoFilledCanContactRef.current = true;
        setCanContactDefault(true);
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("section", {
        "aria-labelledby": "contextualSurveyQuestion",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        id: "contextualSurveyQuestion",
                        size: "xsmall",
                        as: "h2",
                        children: question
                    }),
                    statement && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        id: "contextualSurveyStatement",
                        children: statement
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3L3Os.default), {
                onSubmit: onSubmit,
                children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
                                name: "feedbackScore",
                                isDisabled: submitting,
                                isRequired: true,
                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $18XQs.default), {
                                        ...fieldProps,
                                        onChange: (score)=>{
                                            fieldProps.onChange(score);
                                            onScoreSelect();
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1aLTh.default), {
                                in: expanded,
                                timeout: $317628e901f9ae29$var$transitionDuration,
                                mountOnEnter: true,
                                children: (state)=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                                        style: {
                                            transition: `max-height ${$317628e901f9ae29$var$transitionDuration}ms ease-in-out`,
                                            maxHeight: $317628e901f9ae29$var$getExpandedHeight(expandedAreaRef, state)
                                        },
                                        ref: expandedAreaRef,
                                        className: (0, $hcewu.default)([
                                            "_1reo15vq _18m915vq"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
                                                name: "writtenFeedback",
                                                defaultValue: "",
                                                isDisabled: submitting,
                                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQmi3.default), {
                                                        ...fieldProps,
                                                        "aria-label": textLabel,
                                                        placeholder: textPlaceholder,
                                                        onChange: (event)=>{
                                                            fieldProps.onChange(event);
                                                            onFeedbackChange();
                                                        }
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2yMqp.default), {
                                                name: "canContact",
                                                isDisabled: submitting,
                                                defaultIsChecked: canContactDefault,
                                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $86tBw.default), {
                                                        ...fieldProps,
                                                        label: "Atlassian can contact me about this feedback"
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eRpdx.default), {
                                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                                                    type: "submit",
                                                    appearance: "primary",
                                                    isLoading: submitting,
                                                    children: "Submit"
                                                })
                                            })
                                        ]
                                    })
                            })
                        ]
                    })
            })
        ]
    });
};

});
parcelRegister("86tBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $43629aa548cc82fb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $cM2mi = parcelRequire("cM2mi");
var $jJLKy = parcelRequire("jJLKy");
var $9ywMw = parcelRequire("9ywMw");
var $lsp6q = parcelRequire("lsp6q");
const $43629aa548cc82fb$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $43629aa548cc82fb$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $gyJTO.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jJLKy.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $43629aa548cc82fb$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cM2mi.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ywMw.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsp6q.default), {})
                ]
            })
        ]
    });
}));
$43629aa548cc82fb$var$Checkbox.displayName = 'Checkbox';
var $43629aa548cc82fb$export$2e2bcd8739ae039 = $43629aa548cc82fb$var$Checkbox;

});
parcelRegister("cM2mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b89a586a6c2ef726$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
function $b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $b89a586a6c2ef726$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $b89a586a6c2ef726$export$2e2bcd8739ae039 = $b89a586a6c2ef726$var$CheckboxIcon;

});

parcelRegister("jJLKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4573aabb850f2ff0$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4573aabb850f2ff0$var$baseStyles = null;
const $4573aabb850f2ff0$var$textLabelLayoutStyles = null;
const $4573aabb850f2ff0$var$disabledStyles = null;
const $4573aabb850f2ff0$var$labelStyles = null;
function $4573aabb850f2ff0$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("9ywMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $94306373cce3a9fe$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $94306373cce3a9fe$var$labelTextStyles = null;
function $94306373cce3a9fe$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("lsp6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bafcc116ddbb4544$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bafcc116ddbb4544$var$requiredIndicatorStyles = null;
function $bafcc116ddbb4544$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("2yMqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $636b62edc5d062fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $636b62edc5d062fa$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value, ...rest })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $eJOHy.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        ...rest,
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
var $636b62edc5d062fa$export$2e2bcd8739ae039 = $636b62edc5d062fa$var$CheckboxField;

});

parcelRegister("eRpdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6411efa125c19813$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6411efa125c19813$var$formFooterWrapperStyles = null;
const $6411efa125c19813$var$justifyContentStyles = null;
function $6411efa125c19813$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("footer", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("dQmi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef995104f62942f4$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $eGOwo = parcelRequire("eGOwo");
const $ef995104f62942f4$var$packageName = "platform-pkg";
const $ef995104f62942f4$var$packageVersion = "0.0.0-use.local";
const $ef995104f62942f4$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $ef995104f62942f4$var$packageName,
    packageVersion: $ef995104f62942f4$var$packageVersion
};
const $ef995104f62942f4$var$lineHeightBase = 20;
const $ef995104f62942f4$var$lineHeightCompact = 16;
const $ef995104f62942f4$var$compactVerticalPadding = 2;
const $ef995104f62942f4$var$verticalPadding = 6;
const $ef995104f62942f4$var$transitionDuration = '0.2s';
const $ef995104f62942f4$var$borderWidth = 2;
const $ef995104f62942f4$var$baseStyles = null;
const $ef995104f62942f4$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $ef995104f62942f4$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $ef995104f62942f4$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $ef995104f62942f4$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $ef995104f62942f4$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $ef995104f62942f4$var$InnerTextArea = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const ourRef = (0, $eJOHy.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $eJOHy.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eJOHy.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $ef995104f62942f4$var$appearanceStyles[appearance],
            (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && $ef995104f62942f4$var$fontStyles['large'],
            $ef995104f62942f4$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $ef995104f62942f4$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightCompact * minimumRows + $ef995104f62942f4$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightBase * minimumRows + $ef995104f62942f4$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $ef995104f62942f4$var$TextArea = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ef995104f62942f4$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$ef995104f62942f4$var$TextArea.displayName = 'TextArea';
var $ef995104f62942f4$export$2e2bcd8739ae039 = $ef995104f62942f4$var$TextArea;

});

parcelRegister("18XQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d8c9bb7d4a0e97$export$2e2bcd8739ae039);
/* FeedbackScoreButtons.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5CSKW = parcelRequire("5CSKW");

var $3cMgR = parcelRequire("3cMgR");

var $k71qx = parcelRequire("k71qx");
const $b8d8c9bb7d4a0e97$var$tooltipMessage = [
    'Strongly disagree',
    'Disagree',
    'Slightly disagree',
    'Neutral',
    'Slightly agree',
    'Agree',
    'Strongly agree'
];
const $b8d8c9bb7d4a0e97$var$buttonWrapperStyles = null;
const $b8d8c9bb7d4a0e97$var$descriptionWrapperStyles = null;
var $b8d8c9bb7d4a0e97$export$2e2bcd8739ae039 = ({ onChange: onChange, value: value })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _1bah1yb4 _zdxokb7n _v5ynkb7n _13lsf1ug _1o0a1h6o _pof3u2gc"
                ]),
                children: Array.from({
                    length: 7
                }, (_, i)=>{
                    const score = i + 1;
                    const isSelected = value === score;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: $b8d8c9bb7d4a0e97$var$tooltipMessage[i],
                        hideTooltipOnClick: true,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                            onClick: ()=>onChange(score),
                            isSelected: isSelected,
                            "aria-pressed": isSelected,
                            "aria-describedby": "contextualSurveyStatement",
                            "aria-label": $b8d8c9bb7d4a0e97$var$tooltipMessage[i],
                            shouldFitContainer: true,
                            children: score
                        })
                    }, score);
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                "aria-hidden": true,
                className: (0, $hcewu.default)([
                    "_1e0c1txw _19pku2gc _otyr1ejb _1bah1yb4 _nbgx1epz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        color: "color.text.subtlest",
                        size: "UNSAFE_small",
                        weight: "semibold",
                        align: "start",
                        children: "Strongly disagree"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        color: "color.text.subtlest",
                        size: "UNSAFE_small",
                        weight: "semibold",
                        align: "center",
                        children: "Neutral"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        color: "color.text.subtlest",
                        size: "UNSAFE_small",
                        weight: "semibold",
                        align: "end",
                        children: "Strongly agree"
                    })
                ]
            })
        ]
    });

});


parcelRegister("kdDGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c59cf9c095e5117$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $1c59cf9c095e5117$export$4e7f196112fea3c5 = 27;
function $1c59cf9c095e5117$var$bind(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function unbind() {
        target.removeEventListener(eventName, handler, options);
    };
}
function $1c59cf9c095e5117$var$shouldDismiss(target) {
    if (!target) return true;
    if (!(target instanceof HTMLElement)) return true;
    // Closest doesn't exist for ie11
    // Because we cannot be sure if in a text area - just don't allow dismissing
    if (!target.closest) return false;
    const inTextArea = Boolean(target.closest('textarea'));
    // Allow dismissing if not in a textarea
    return !inTextArea;
}
function $1c59cf9c095e5117$export$2e2bcd8739ae039({ onDismiss: onDismiss }) {
    const onDismissRef = (0, $eJOHy.useRef)(onDismiss);
    // Defensively accounting for consumer passing in a new function
    // each time. We just want to call the latest one
    (0, $eJOHy.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let unbind;
        function onKeyDown(event) {
            if (event.keyCode !== $1c59cf9c095e5117$export$4e7f196112fea3c5) return;
            // Escape pressed
            // We don't want to close if the user is typing in the text area
            if (!$1c59cf9c095e5117$var$shouldDismiss(event.target)) return;
            if (unbind) // only want to call dismiss once
            unbind();
            onDismissRef.current();
        }
        unbind = $1c59cf9c095e5117$var$bind(window, 'keydown', // @ts-ignore: the typescript for this is lame
        onKeyDown, {
            passive: true
        });
        // double calls to unbind is fine
        return unbind;
    }, []);
}

});





parcelRegister("ajjxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a89670e7d7468d$export$2e2bcd8739ae039);

var $9vPaT = parcelRequire("9vPaT");

var $5nYbP = parcelRequire("5nYbP");

var $1Upy5 = parcelRequire("1Upy5");
const $a9a89670e7d7468d$export$8423d11067fbf579 = (0, $9vPaT.default)((0, $1Upy5.default));
var $a9a89670e7d7468d$export$2e2bcd8739ae039 = (0, $5nYbP.default)($a9a89670e7d7468d$export$8423d11067fbf579, 'flag');

});
parcelRegister("1Upy5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b661996a41ba308a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $h0TP6 = parcelRequire("h0TP6");
var $gPCVG = parcelRequire("gPCVG");

var $9BCGk = parcelRequire("9BCGk");

var $bK1H5 = parcelRequire("bK1H5");

var $w3oMh = parcelRequire("w3oMh");
class $b661996a41ba308a$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            primaryText: null,
            primaryAction: null,
            secondaryText: null,
            secondaryAction: null,
            icon: 'smallInfo'
        };
    }
    onClickActionHandler(action) {
        if (action && action.type === (0, $9BCGk.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
    }
    render() {
        const { title: title, body: body, primaryText: primaryText, secondaryText: secondaryText, icon: icon } = this.props;
        const actions = [
            {
                content: primaryText,
                onClick: this.onPrimaryClick
            }
        ];
        if (secondaryText) actions.push({
            content: secondaryText,
            onClick: this.onSecondaryClick
        });
        const selectedIcon = (0, $w3oMh.default)[icon];
        const FlagIconComponent = selectedIcon && selectedIcon.component;
        const FlagIcon = FlagIconComponent ? /*#__PURE__*/ (0, $gt9Am.jsx)(FlagIconComponent, {
            label: selectedIcon.label,
            color: selectedIcon.color,
            spacing: "spacious"
        }) : null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gPCVG.default), {
            onDismissed: this.onDismiss,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h0TP6.default), {
                id: "engagement-flag",
                appearance: "normal",
                icon: FlagIcon,
                title: title,
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bK1H5.default), {
                    html: body
                }),
                actions: actions
            })
        });
    }
    constructor(...args){
        super(...args), this.onDismiss = ()=>{
            this.props.fireClickEvent('dismiss');
        }, this.onPrimaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, primaryAction: primaryAction } = this.props;
            fireClickEvent('primary');
            this.onClickActionHandler(primaryAction);
        }, this.onSecondaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, secondaryAction: secondaryAction } = this.props;
            fireClickEvent('secondary');
            this.onClickActionHandler(secondaryAction);
        };
    }
}

});
parcelRegister("w3oMh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d54acefef5945e$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-relative-package-imports, @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/entry-points, @atlassian/tangerine/import/no-parent-imports */ 
var $4b867 = parcelRequire("4b867");

var $amxqt = parcelRequire("amxqt");

var $kHcBe = parcelRequire("kHcBe");

var $d3cA1 = parcelRequire("d3cA1");

var $gvSye = parcelRequire("gvSye");

var $dSeZ6 = parcelRequire("dSeZ6");

var $7kJQm = parcelRequire("7kJQm");

var $3Isp2 = parcelRequire("3Isp2");

const $f7d54acefef5945e$var$flagMapping = {
    success: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4b867))),
        label: 'success',
        color: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$exports).G300})`
    },
    error: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))),
        label: 'error',
        color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$exports).R300})`
    },
    info: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7kJQm))),
        label: 'info',
        color: `var(--ds-icon-information, ${(0, $7bb4c1736002a04a$exports).T300})`
    },
    warning: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($3Isp2))),
        label: 'warning',
        color: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$exports).Y300})`
    },
    smallInfo: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dSeZ6))),
        label: 'info',
        color: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$exports).P300})`
    },
    comment: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($amxqt))),
        label: 'comment',
        color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$exports).N300})`
    },
    download: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($kHcBe))),
        label: 'download',
        color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$exports).N300})`
    },
    feedback: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($gvSye))),
        label: 'comment',
        color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$exports).N300})`
    }
};
var $f7d54acefef5945e$export$2e2bcd8739ae039 = $f7d54acefef5945e$var$flagMapping;

});
parcelRegister("amxqt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfb8e24ad0aeafedb3c07855964a196e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78b5e325967a99e4$var$_react = $78b5e325967a99e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78b5e325967a99e4$var$_comment = $78b5e325967a99e4$var$_interopRequireDefault((parcelRequire("gDKBr")));

var $78b5e325967a99e4$var$_comment2 = $78b5e325967a99e4$var$_interopRequireDefault((parcelRequire("04OD1")));
function $78b5e325967a99e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommentIcon.
 * This component is CommentIcon, with `UNSAFE_fallbackIcon` set to "CommentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78b5e325967a99e4$var$CommentIcon = (props)=>/*#__PURE__*/ $78b5e325967a99e4$var$_react.default.createElement($78b5e325967a99e4$var$_comment.default, Object.assign({
        LEGACY_fallbackIcon: $78b5e325967a99e4$var$_comment2.default
    }, props));
$78b5e325967a99e4$var$CommentIcon.Name = 'CommentIconMigration';
var $78b5e325967a99e4$var$_default = module.exports.default = $78b5e325967a99e4$var$CommentIcon;

});
parcelRegister("gDKBr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1d470387d991694$var$_react = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c1d470387d991694$var$_baseNew = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c1d470387d991694$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1d470387d991694$var$CommentIcon = (props)=>/*#__PURE__*/ $c1d470387d991694$var$_react.default.createElement($c1d470387d991694$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$c1d470387d991694$var$CommentIcon.displayName = 'CommentIcon';
var $c1d470387d991694$var$_default = module.exports.default = $c1d470387d991694$var$CommentIcon;

});

parcelRegister("04OD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00e7a599837ddc3e$var$_react = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $00e7a599837ddc3e$var$_comment = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("gDKBr")));
function $00e7a599837ddc3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $00e7a599837ddc3e$var$CommentIcon = (props)=>/*#__PURE__*/ $00e7a599837ddc3e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $00e7a599837ddc3e$var$_comment.default
    }));
$00e7a599837ddc3e$var$CommentIcon.displayName = 'CommentIcon';
var $00e7a599837ddc3e$var$_default = module.exports.default = $00e7a599837ddc3e$var$CommentIcon;

});


parcelRegister("kHcBe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f11198d3276cd080$var$_react = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f11198d3276cd080$var$_download = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("5Mb5i")));

var $f11198d3276cd080$var$_download2 = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("bRp3T")));
function $f11198d3276cd080$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f11198d3276cd080$var$DownloadIcon = (props)=>/*#__PURE__*/ $f11198d3276cd080$var$_react.default.createElement($f11198d3276cd080$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $f11198d3276cd080$var$_download2.default
    }, props));
$f11198d3276cd080$var$DownloadIcon.Name = 'DownloadIconMigration';
var $f11198d3276cd080$var$_default = module.exports.default = $f11198d3276cd080$var$DownloadIcon;

});
parcelRegister("5Mb5i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $434a088e5f2bb7a6$var$_react = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $434a088e5f2bb7a6$var$_baseNew = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $434a088e5f2bb7a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $434a088e5f2bb7a6$var$DownloadIcon = (props)=>/*#__PURE__*/ $434a088e5f2bb7a6$var$_react.default.createElement($434a088e5f2bb7a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$434a088e5f2bb7a6$var$DownloadIcon.displayName = 'DownloadIcon';
var $434a088e5f2bb7a6$var$_default = module.exports.default = $434a088e5f2bb7a6$var$DownloadIcon;

});

parcelRegister("bRp3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2815b0aa140afa$var$_react = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $8a2815b0aa140afa$var$_download = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("5Mb5i")));
function $8a2815b0aa140afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a2815b0aa140afa$var$DownloadIcon = (props)=>/*#__PURE__*/ $8a2815b0aa140afa$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $8a2815b0aa140afa$var$_download.default
    }));
$8a2815b0aa140afa$var$DownloadIcon.displayName = 'DownloadIcon';
var $8a2815b0aa140afa$var$_default = module.exports.default = $8a2815b0aa140afa$var$DownloadIcon;

});


parcelRegister("d3cA1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::65cdc00c41545a5e974b615c0e363097>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98055050e3fd2f5f$var$_react = $98055050e3fd2f5f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $98055050e3fd2f5f$var$_error = $98055050e3fd2f5f$var$_interopRequireDefault((parcelRequire("l3UDk")));

var $98055050e3fd2f5f$var$_error2 = $98055050e3fd2f5f$var$_interopRequireDefault((parcelRequire("duLdC")));
function $98055050e3fd2f5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98055050e3fd2f5f$var$ErrorIcon = (props)=>/*#__PURE__*/ $98055050e3fd2f5f$var$_react.default.createElement($98055050e3fd2f5f$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $98055050e3fd2f5f$var$_error2.default
    }, props));
$98055050e3fd2f5f$var$ErrorIcon.Name = 'ErrorIconMigration';
var $98055050e3fd2f5f$var$_default = module.exports.default = $98055050e3fd2f5f$var$ErrorIcon;

});
parcelRegister("l3UDk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2cd3105f02ad146f4ebeeb5e7e40633>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f555cf0116fa7f25$var$_react = $f555cf0116fa7f25$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f555cf0116fa7f25$var$_baseNew = $f555cf0116fa7f25$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f555cf0116fa7f25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f555cf0116fa7f25$var$ErrorIcon = (props)=>/*#__PURE__*/ $f555cf0116fa7f25$var$_react.default.createElement($f555cf0116fa7f25$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$f555cf0116fa7f25$var$ErrorIcon.displayName = 'ErrorIcon';
var $f555cf0116fa7f25$var$_default = module.exports.default = $f555cf0116fa7f25$var$ErrorIcon;

});


parcelRegister("gvSye", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c059db4c9cb6458b$var$_react = $c059db4c9cb6458b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c059db4c9cb6458b$var$_feedback = $c059db4c9cb6458b$var$_interopRequireDefault((parcelRequire("8c712")));

var $c059db4c9cb6458b$var$_feedback2 = $c059db4c9cb6458b$var$_interopRequireDefault((parcelRequire("9ryJx")));
function $c059db4c9cb6458b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c059db4c9cb6458b$var$FeedbackIcon = (props)=>/*#__PURE__*/ $c059db4c9cb6458b$var$_react.default.createElement($c059db4c9cb6458b$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $c059db4c9cb6458b$var$_feedback2.default
    }, props));
$c059db4c9cb6458b$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $c059db4c9cb6458b$var$_default = module.exports.default = $c059db4c9cb6458b$var$FeedbackIcon;

});
parcelRegister("8c712", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f74e2e78935ad1f$var$_react = $5f74e2e78935ad1f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5f74e2e78935ad1f$var$_baseNew = $5f74e2e78935ad1f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5f74e2e78935ad1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f74e2e78935ad1f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $5f74e2e78935ad1f$var$_react.default.createElement($5f74e2e78935ad1f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$5f74e2e78935ad1f$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $5f74e2e78935ad1f$var$_default = module.exports.default = $5f74e2e78935ad1f$var$FeedbackIcon;

});

parcelRegister("9ryJx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e0193feeccc2658$var$_react = $6e0193feeccc2658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $6e0193feeccc2658$var$_feedback = $6e0193feeccc2658$var$_interopRequireDefault((parcelRequire("8c712")));
function $6e0193feeccc2658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6e0193feeccc2658$var$FeedbackIcon = (props)=>/*#__PURE__*/ $6e0193feeccc2658$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $6e0193feeccc2658$var$_feedback.default
    }));
$6e0193feeccc2658$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $6e0193feeccc2658$var$_default = module.exports.default = $6e0193feeccc2658$var$FeedbackIcon;

});


parcelRegister("dSeZ6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::921c43387c7852c5edb9fb15d3707fce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a19bf121c55870dc$var$_react = $a19bf121c55870dc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a19bf121c55870dc$var$_information = $a19bf121c55870dc$var$_interopRequireDefault((parcelRequire("6eUFQ")));

var $a19bf121c55870dc$var$_info = $a19bf121c55870dc$var$_interopRequireDefault((parcelRequire("eAsyt")));
function $a19bf121c55870dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorInfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a19bf121c55870dc$var$InformationIcon = (props)=>/*#__PURE__*/ $a19bf121c55870dc$var$_react.default.createElement($a19bf121c55870dc$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $a19bf121c55870dc$var$_info.default
    }, props));
$a19bf121c55870dc$var$InformationIcon.Name = 'InformationIconMigration';
var $a19bf121c55870dc$var$_default = module.exports.default = $a19bf121c55870dc$var$InformationIcon;

});
parcelRegister("6eUFQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48b00326389bdb1b$var$_react = $48b00326389bdb1b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $48b00326389bdb1b$var$_baseNew = $48b00326389bdb1b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $48b00326389bdb1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48b00326389bdb1b$var$InformationIcon = (props)=>/*#__PURE__*/ $48b00326389bdb1b$var$_react.default.createElement($48b00326389bdb1b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$48b00326389bdb1b$var$InformationIcon.displayName = 'InformationIcon';
var $48b00326389bdb1b$var$_default = module.exports.default = $48b00326389bdb1b$var$InformationIcon;

});

parcelRegister("eAsyt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9ea93e742aa0026$var$_react = $a9ea93e742aa0026$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $a9ea93e742aa0026$var$_statusInformation = $a9ea93e742aa0026$var$_interopRequireDefault((parcelRequire("2R0ne")));
function $a9ea93e742aa0026$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9ea93e742aa0026$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $a9ea93e742aa0026$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $a9ea93e742aa0026$var$_statusInformation.default
    }));
$a9ea93e742aa0026$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $a9ea93e742aa0026$var$_default = module.exports.default = $a9ea93e742aa0026$var$EditorInfoIcon;

});


parcelRegister("7kJQm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cba8aea4f01e137899fc410e6d59c613>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $556df636e54f1375$var$_react = $556df636e54f1375$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $556df636e54f1375$var$_information = $556df636e54f1375$var$_interopRequireDefault((parcelRequire("6eUFQ")));

var $556df636e54f1375$var$_info = $556df636e54f1375$var$_interopRequireDefault((parcelRequire("cDDv2")));
function $556df636e54f1375$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $556df636e54f1375$var$InformationIcon = (props)=>/*#__PURE__*/ $556df636e54f1375$var$_react.default.createElement($556df636e54f1375$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $556df636e54f1375$var$_info.default
    }, props));
$556df636e54f1375$var$InformationIcon.Name = 'InformationIconMigration';
var $556df636e54f1375$var$_default = module.exports.default = $556df636e54f1375$var$InformationIcon;

});

parcelRegister("3Isp2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d5fac6bc179ab80298f715340f91ebf9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b4b8363d3e15500$var$_react = $2b4b8363d3e15500$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2b4b8363d3e15500$var$_warning = $2b4b8363d3e15500$var$_interopRequireDefault((parcelRequire("dUhgd")));

var $2b4b8363d3e15500$var$_warning2 = $2b4b8363d3e15500$var$_interopRequireDefault((parcelRequire("60rxg")));
function $2b4b8363d3e15500$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b4b8363d3e15500$var$WarningIcon = (props)=>/*#__PURE__*/ $2b4b8363d3e15500$var$_react.default.createElement($2b4b8363d3e15500$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $2b4b8363d3e15500$var$_warning2.default
    }, props));
$2b4b8363d3e15500$var$WarningIcon.Name = 'WarningIconMigration';
var $2b4b8363d3e15500$var$_default = module.exports.default = $2b4b8363d3e15500$var$WarningIcon;

});
parcelRegister("dUhgd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1fde4e6e34c594b$var$_react = $a1fde4e6e34c594b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a1fde4e6e34c594b$var$_baseNew = $a1fde4e6e34c594b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $a1fde4e6e34c594b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1fde4e6e34c594b$var$WarningIcon = (props)=>/*#__PURE__*/ $a1fde4e6e34c594b$var$_react.default.createElement($a1fde4e6e34c594b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$a1fde4e6e34c594b$var$WarningIcon.displayName = 'WarningIcon';
var $a1fde4e6e34c594b$var$_default = module.exports.default = $a1fde4e6e34c594b$var$WarningIcon;

});





parcelRegister("kcfPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $02cae0aee062dc94$export$2e2bcd8739ae039);

var $9vPaT = parcelRequire("9vPaT");

var $5nYbP = parcelRequire("5nYbP");

var $bB3lx = parcelRequire("bB3lx");
const $02cae0aee062dc94$export$404a075b2b026e91 = (0, $9vPaT.default)((0, $bB3lx.default));
var $02cae0aee062dc94$export$2e2bcd8739ae039 = (0, $5nYbP.default)($02cae0aee062dc94$export$404a075b2b026e91, 'modalDialog');

});
parcelRegister("bB3lx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac5c5afeca496bd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $h1Srn = parcelRequire("h1Srn");

var $9BCGk = parcelRequire("9BCGk");

var $bK1H5 = parcelRequire("bK1H5");
function $3ac5c5afeca496bd$var$header() {
    return null;
}
class $3ac5c5afeca496bd$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    getActionButton(action, text, onClick) {
        return {
            text: text,
            onClick: (e)=>{
                if (action.type === (0, $9BCGk.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
                onClick(e);
            }
        };
    }
    getActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (primaryAction && primaryText) actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
        if (secondaryAction && secondaryText) actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
        return actions;
    }
    getAdditionalModalProps() {
        const props = {};
        const { imageSrc: imageSrc } = this.props;
        if (imageSrc) props.image = imageSrc;
        else props.header = $3ac5c5afeca496bd$var$header;
        return props;
    }
    render() {
        const { title: title, body: body } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h1Srn.default), {
            actions: this.getActions(),
            heading: title,
            ...this.getAdditionalModalProps(),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bK1H5.default), {
                html: body
            })
        });
    }
    constructor(...args){
        super(...args), this.onPrimaryAction = ()=>{
            this.props.fireClickEvent('primary');
        }, this.onSecondaryAction = ()=>{
            this.props.fireClickEvent('secondary');
        };
    }
}

});
parcelRegister("h1Srn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9f4cac3640ab75e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $abjs4 = parcelRequire("abjs4");
var $lBX28 = parcelRequire("lBX28");

var $gHHv2 = parcelRequire("gHHv2");
var $ik0CA = parcelRequire("ik0CA");
var $ioK9M = parcelRequire("ioK9M");

var $jNGsB = parcelRequire("jNGsB");

var $71NNK = parcelRequire("71NNK");
class $a9f4cac3640ab75e$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { actions: actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $ioK9M.useModal)();
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jNGsB.ModalHeading), {
                id: titleId,
                children: heading
            });
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gHHv2.default), {
            autoFocus: true,
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)(Header, {}),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jNGsB.ModalBody), {
                        children: [
                            heading && /*#__PURE__*/ (0, $gt9Am.jsx)(CustomHeader, {}),
                            children
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)(Footer, {})
            ]
        }));
    }
    constructor(...args){
        super(...args), this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jNGsB.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        }, this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBX28.default).Provider, {
                    value: (0, $71NNK.modalButtonTheme),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jNGsB.ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight,
                        children: actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                            const variant = idx ? 'subtle-link' : 'primary';
                            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jNGsB.ModalActionItem), {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $abjs4.default), {
                                    appearance: variant,
                                    autoFocus: !idx,
                                    ...rest,
                                    children: text
                                })
                            }, key || (typeof text === 'string' ? text : `${idx}`));
                        })
                    })
                }) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("jNGsB", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $5cad23b72adaeb34$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $5cad23b72adaeb34$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $5cad23b72adaeb34$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $5cad23b72adaeb34$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $5cad23b72adaeb34$export$c245e9f76e3299b1);
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");
const $5cad23b72adaeb34$var$modalBodyStyles = null;
const $5cad23b72adaeb34$var$modalHeadingStyles = null;
const $5cad23b72adaeb34$var$modalImageStyles = null;
const $5cad23b72adaeb34$var$modalActionContainerStyles = null;
const $5cad23b72adaeb34$var$modalActionContainerReversedStyles = null;
const $5cad23b72adaeb34$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
};
const $5cad23b72adaeb34$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ]),
        children: children
    });
const $5cad23b72adaeb34$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("h1", {
        id: id,
        className: (0, $hcewu.default)([
            "_11c8lodh _syaz1kw7 _6rthu2gc"
        ]),
        children: children
    });
};
const $5cad23b72adaeb34$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        alt: alt,
        src: src,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1wug _5fbc1sit _1s1g1sit _j722idpf"
        ])
    });
const $5cad23b72adaeb34$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ]),
        children: children
    });
const $5cad23b72adaeb34$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $5cad23b72adaeb34$var$modalActionItemStyles.root,
        children: children
    });

});







//# sourceMappingURL=async-engagement-spotlight.325e231e.js.map
